import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ConsultaComponent } from "./components/consulta/consulta.component";
import { ReclamacionComponent } from "./components/reclamacion/reclamacion.component";

@Component({
  selector: 'app-accidentes',
  standalone: true,
  imports: [CommonModule, FormsModule, ConsultaComponent, ReclamacionComponent],
  template: `
    <div>
      <!-- Consulta -->
      <accidentes-consulta></accidentes-consulta>
      <!-- Reclamacion -->
      <accidentes-reclamacion></accidentes-reclamacion>
    </div>`
})
export class AccidentesComponent { }
